export const jp = {
  jp: {
    logout: `ログアウト`,
    game: `game`,
    history: `history`,
    back: `back`,
    maintenance: `maintenance`,
    maintenance_desc: `We will be back shortly`,
    play_now: `play now`,

    logout_title: `<i class="tx--logout -jp"></i>`,
    alert_title: `<i class="tx--alert -jp"></i>`,
    chat_title: `<i class="tx--chat -jp"></i>`,

    sort: `ソート`,

    //= language
    language: [
      { id: 0, name: 'en' },
      { id: 2, name: 'jp' },
      { id: 1, name: 'kr' },
      { id: 3, name: 'zh' }
    ],

    //= navigation
    home: `トップ`,
    popular: `大人気`,
    live_games: `ライブゲーム`,
    table_games: `テーブルゲーム`,
    slot_games: `スロットゲーム`,
    other_games: `その他のゲーム`,

    //= alerts
    error: `エラー`,
    prompt: `are you sure?`,
    info: `詳細`,
    success: `成功`,

    ok: `ＯＫ`,
    cancel: `取消`,
    failed: `失败`,

    //= titles
    slot_payline: `スロットペイライン`,
    game_provider: `ソフトウェア`,
    faq: `faq`
  }
}
